"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableStylesheetsAsSelectInputOptions = exports.getAvailableStylesheets = exports.getAttachedStylesheetIds = exports.getAllDomainsAttachedStylesheetsAsImmutableList = exports.getAllDomainsAttachedStylesheetsAsArray = exports.getAttachedStylesheetsAsImmutableList = exports.getAttachedStylesheetsAsArray = exports.getAttachedStylesheets = exports.getAllDomainsAttachedStylesheets = exports.getNumberOfStagedChanges = exports.getHasChangedAttachedStylesheets = exports.getCurrentAttachedStylesheets = exports.getStagedAttachedStylesheets = void 0;

var _reselect = require("reselect");

var _immutable = require("immutable");

var _selectors = require("settings-ui-sdk/DesignTemplates/selectors");

var _UpdateSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateSiteSettings"));

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _selectors2 = require("settings-ui-sdk/SiteSettings/selectors");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

/**
 * null is a bit of a special value here, it indicates that we are
 * going to inherit a value from the all domains level, so we want
 * to pass it to the UI in most cases, and not coerce it into a array.
 */
var INHERIT_FROM_ALL_DOMAINS_VALUE = null;

var getStagingForAttachedStylesheets = function getStagingForAttachedStylesheets(state) {
  return state.modules[_UrlPathParams.WEBSITE][_UrlPathParams.PAGES].staging[_constants.ATTACHED_STYLESHEETS];
};

var getStagedAttachedStylesheets = (0, _reselect.createSelector)([getStagingForAttachedStylesheets], function (stagingForAttachedStylesheets) {
  return stagingForAttachedStylesheets.get('staged');
});
exports.getStagedAttachedStylesheets = getStagedAttachedStylesheets;
var getCurrentAttachedStylesheets = (0, _reselect.createSelector)([getStagingForAttachedStylesheets], function (stagingForAttachedStylesheets) {
  return stagingForAttachedStylesheets.get('current');
});
exports.getCurrentAttachedStylesheets = getCurrentAttachedStylesheets;
var getHasChangedAttachedStylesheets = (0, _reselect.createSelector)([getStagedAttachedStylesheets, getCurrentAttachedStylesheets], function (stagedAttachedStylesheets, currentAttachedStylesheets) {
  if (stagedAttachedStylesheets === INHERIT_FROM_ALL_DOMAINS_VALUE && currentAttachedStylesheets !== INHERIT_FROM_ALL_DOMAINS_VALUE || stagedAttachedStylesheets !== INHERIT_FROM_ALL_DOMAINS_VALUE && currentAttachedStylesheets === INHERIT_FROM_ALL_DOMAINS_VALUE) {
    return true;
  }

  var staged = stagedAttachedStylesheets ? stagedAttachedStylesheets.toArray() : [];
  var current = currentAttachedStylesheets ? currentAttachedStylesheets.toArray() : [];

  if (staged.length !== current.length) {
    return true;
  }

  return current.some(function (stylesheet, idx) {
    return stylesheet.id !== staged[idx].id;
  });
});
exports.getHasChangedAttachedStylesheets = getHasChangedAttachedStylesheets;
var getNumberOfStagedChanges = (0, _reselect.createSelector)([_UpdateSiteSettings.default.isChanged(_constants.ALL_DOMAINS_OR_DOMAIN_NAME), _UpdateSiteSettings.default.numberOfChanges, getHasChangedAttachedStylesheets], function (isChanged, numberOfChanges, hasChangedAttachedStylesheets) {
  if (isChanged) {
    return 0;
  }

  return numberOfChanges + (hasChangedAttachedStylesheets ? 1 : 0);
});
exports.getNumberOfStagedChanges = getNumberOfStagedChanges;
var getAllDomainsAttachedStylesheets = (0, _reselect.createSelector)([_selectors.getStylesheets, _selectors2.getAllDomainsSiteSettings], function (stylesheets, allDomainsSiteSettings) {
  var allDomainsAttachedStylesheets = allDomainsSiteSettings.get(_constants.ATTACHED_STYLESHEETS);

  if (allDomainsAttachedStylesheets && stylesheets.size > 0) {
    return allDomainsAttachedStylesheets.reduce(function (acc, stylesheet) {
      if (stylesheets.has(stylesheet.id)) {
        return acc.set(stylesheet.id, stylesheets.get(stylesheet.id));
      }

      return acc;
    }, (0, _immutable.OrderedMap)());
  }

  return new _immutable.OrderedMap();
});
exports.getAllDomainsAttachedStylesheets = getAllDomainsAttachedStylesheets;
var getAttachedStylesheets = (0, _reselect.createSelector)([_selectors.getStylesheets, getStagedAttachedStylesheets], function (stylesheets, attachedStylesheets) {
  if (attachedStylesheets === INHERIT_FROM_ALL_DOMAINS_VALUE) {
    return INHERIT_FROM_ALL_DOMAINS_VALUE;
  }

  if (attachedStylesheets && stylesheets.size > 0) {
    return attachedStylesheets.reduce(function (acc, stylesheet) {
      if (stylesheets.has(stylesheet.id)) {
        return acc.set(stylesheet.id, stylesheets.get(stylesheet.id));
      }

      return acc;
    }, (0, _immutable.OrderedMap)());
  }

  return new _immutable.OrderedMap();
});
exports.getAttachedStylesheets = getAttachedStylesheets;
var getAttachedStylesheetsAsArray = (0, _reselect.createSelector)([getAttachedStylesheets], function (attachedStylesheets) {
  if (attachedStylesheets === INHERIT_FROM_ALL_DOMAINS_VALUE) {
    return INHERIT_FROM_ALL_DOMAINS_VALUE;
  }

  return attachedStylesheets.valueSeq().toArray();
});
exports.getAttachedStylesheetsAsArray = getAttachedStylesheetsAsArray;
var getAttachedStylesheetsAsImmutableList = (0, _reselect.createSelector)([getAttachedStylesheetsAsArray], function (attachedStylesheets) {
  if (attachedStylesheets === INHERIT_FROM_ALL_DOMAINS_VALUE) {
    return INHERIT_FROM_ALL_DOMAINS_VALUE;
  }

  return (0, _selectors.formatForDragAndDrop)(attachedStylesheets);
});
exports.getAttachedStylesheetsAsImmutableList = getAttachedStylesheetsAsImmutableList;
var getAllDomainsAttachedStylesheetsAsArray = (0, _reselect.createSelector)([getAllDomainsAttachedStylesheets], function (allDomainsattachedStylesheets) {
  return allDomainsattachedStylesheets.valueSeq().toArray();
});
exports.getAllDomainsAttachedStylesheetsAsArray = getAllDomainsAttachedStylesheetsAsArray;
var getAllDomainsAttachedStylesheetsAsImmutableList = (0, _reselect.createSelector)([getAllDomainsAttachedStylesheetsAsArray], function (allDomainsAttachedStylesheetsAsArray) {
  return (0, _selectors.formatForDragAndDrop)(allDomainsAttachedStylesheetsAsArray);
});
exports.getAllDomainsAttachedStylesheetsAsImmutableList = getAllDomainsAttachedStylesheetsAsImmutableList;
var getAttachedStylesheetIds = (0, _reselect.createSelector)([getAttachedStylesheets], function (stylesheets) {
  if (stylesheets === INHERIT_FROM_ALL_DOMAINS_VALUE) {
    return [];
  }

  return stylesheets.reduce(function (acc, stylesheet) {
    acc.push(stylesheet.id);
    return acc;
  }, []);
});
exports.getAttachedStylesheetIds = getAttachedStylesheetIds;
var getAvailableStylesheets = (0, _reselect.createSelector)([_selectors.getStylesheets, getAttachedStylesheetIds], function (stylesheets, attachedStylesheetIds) {
  return stylesheets.filter(function (stylesheet) {
    return attachedStylesheetIds.indexOf(stylesheet.get('id')) === -1;
  });
});
exports.getAvailableStylesheets = getAvailableStylesheets;
var getAvailableStylesheetsAsSelectInputOptions = (0, _reselect.createSelector)([getAvailableStylesheets], function (stylesheets) {
  return (0, _selectors.formatAsSelectInputOptions)(stylesheets);
});
exports.getAvailableStylesheetsAsSelectInputOptions = getAvailableStylesheetsAsSelectInputOptions;